import { COMMISSIONS_ENDPOINT } from '../../endpoints'
import axios from 'axios'

export const getPolicyById = async id => {
  const response = await axios.get(`${COMMISSIONS_ENDPOINT}/${id}`);
  return response.data
}